// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2XMR-","info":"PatientInfo_info__30HCy"};